import React from "react";
import { OrderTypes } from "@shared/features/trades/common/types";
import { StrategyTabs } from "@shared/features/bots/BotForm/common/types";
import BotStrategiesProvider from "@shared/features/bots/BotForm/Strategies/BotStrategiesProvider";
import useSharedBuiltInStrategyForm from "@shared/features/bots/BotForm/Strategies/useSharedBuiltInStrategyForm";
import Select from "common/Select/Select";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface BuiltInStrategiesProps {
  orderType: OrderTypes.ENTRY | OrderTypes.TAKE_PROFIT;
  selectedTab?: StrategyTabs;
}

const BuiltInStrategies = ({
  orderType,
  selectedTab,
}: BuiltInStrategiesProps) => {
  return (
    <BotStrategiesProvider
      orderType={orderType}
      tab={StrategyTabs.BUILT_IN}
      selectedTab={selectedTab}
    >
      <InnerBuiltInStrategies />
    </BotStrategiesProvider>
  );
};

export default BuiltInStrategies;

const InnerBuiltInStrategies = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { builtInStrategiesSelectorData } = useSharedBuiltInStrategyForm();

  return (
    <Select
      style={{ width: "100%" }}
      value={builtInStrategiesSelectorData.value}
      onChange={builtInStrategiesSelectorData.onChange}
      popupMatchSelectWidth={false}
      optionLabelProp="label"
      options={builtInStrategiesSelectorData.options}
      mobileTitle={t("strategy_tabs.built_in_strategies")}
    />
  );
};
